<template>
  <v-container
    id="enrol"
    class="fill-height justify-center"
    tag="section"
  >
   <v-overlay :value="loading">
     <h1 class="text-center">
     {{ $t('global.loading') }}
</h1>
    <v-progress-circular
      indeterminate
      size="64"
    />
    </v-overlay>
    <v-row justify="center">
        <v-card width="600">
          <v-card-title><img id="mark" src="@/assets/Bodyswaps_NO_mark.svg">{{ $t('enrol.class-invitation') }}</v-card-title>
          <v-card-text v-if="!error && !complete">
            <p>{{ $t('enrol.been-invited') }}</p>
            <p>{{ $t('enrol.enter-details') }}</p>
            <p v-html="greetText" />
            <v-form ref="form" v-model="valid">
<v-text-field
                v-model="className"
                readonly
                :label="$t('enrol.class-id')"
                />
              <v-text-field
                v-model="displayName"
                color="secondary"
                :label="$t('enrol.your-name')"
                name="name"
                :rules="[rules.required]"
              />

              <v-text-field
                v-model="email"
                color="secondary"
                :label="$t('enrol.your-email')"
                name="email"
                :rules="[rules.email,permittedDomain]"
                :hint="domainHint"
              />

              <v-switch v-model="remember" :label="$t('enrol.remember-me')" />

              <v-card-actions v-if="!error">
              <v-spacer />
              <v-btn
                color="blue"
                :disabled="!validSubmit"
                @click="submit"
              >
                {{ $t('global.submit') }}
</v-btn>
            </v-card-actions>
            </v-form>
          </v-card-text>

          <v-card-text v-if="error">
              <div v-if="error === 'emailNotFound'">
                <p>{{ $t('enrol.email-address-not-found') }}</p>
                <p>{{ $t('enrol.contact-administrator') }}</p>
                <v-card-actions>
                <v-btn color="blue" @click="reload">
{{ $t('global.back') }}
</v-btn>
              </v-card-actions>
              </div>
              <div v-else-if="error === 'class_full'">
                <p>{{ $t('enrol.class-full') }}</p>
                <p>{{ $t('enrol.contact-administrator') }}</p>
              </div>
              <div v-else-if="error === 'max_users'">
                <p>{{ $t('enrol.max-users') }}</p>
                <p>{{ $t('enrol.contact-administrator') }}</p>
              </div>
              <div v-else-if="error === 'class_expired'">
                <p>{{ $t('sorry-this-class-is-nolonger-accepts-new-participants') }}</p>
                <p>{{ $t('enrol.contact-administrator') }}</p>
              </div>
              <div v-else>
                <p>{{ $t('enrol.bad-link') }}</p>
                <p>{{ $t('enrol.contact-administrator') }}</p>
                <p>{{ $t('enrol.error') }} <b>{{ error }}</b></p>
              <v-card-actions>
                <v-btn color="blue" @click="reload">
{{ $t('global.back') }}
</v-btn>
              </v-card-actions>
              </div>
          </v-card-text>

          <v-card-text v-if="complete">
            <p>{{ $t('enrol.has-been-accepted') }}</p>
            <div v-if="redirectURL">
              <p>{{ $t('enrol.redirection-warning') }}</p>
            </div>
            <div v-else>
            <p>{{ $t('enrol.check-email') }}</p>
            </div>
          </v-card-text>
        </v-card>
    </v-row>
  </v-container>
</template>

<script>
  // import router from '@/router'
  import api from '@/helpers/api.js'
  import { cookies } from '@/util/cookies'

  export default {
    name: 'PagesLogin',

    data () {
      return {
        email: '',
        displayName: '',
        pattern: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        rules: {
          required: value => !!value || 'Required.',
          min: v => v.length >= 9 || this.$t('enrol.require-min-9-characters'),
          email: value => {
            return this.pattern.test(value) || this.$t('enrol.invalid-e-mail')
          },
        },
        enrolmentClass: undefined,
        error: '',
        valid: false,
        show: false,
        loading: false,
        complete: false,
        remember: true,
        redirectURL: undefined,
      }
    },

    computed: {
      className () {
        return this.enrolmentClass ? this.enrolmentClass.name : ''
      },
      classContent () {
        return this.enrolmentClass ? this.enrolmentClass.content : ''
      },
      greetText () {
        return this.enrolmentClass ? this.enrolmentClass.greetText : ''
      },
      domainHint () {
        if (this.permittedDomainArray.length > 0) {
          return this.$t('enrol.domain-should-end-with') + this.permittedDomainArray.join(', ')
        }
        return ''
      },
      emailLabel () {
        if (this.permittedDomainArray.length > 0) {
          return this.$t('enrol.email-address-permitted-domain', [this.permittedDomainArray.join(', ')])
        }
        return this.$t('enrol.email-address')
      },
      validSubmit () {
        const domain = this.email.substring(this.email.indexOf('@'))
        return this.pattern.test(this.email) && this.isDomainPermitted(domain)
      },
      permittedDomainArray () {
        return (this.enrolmentClass && this.enrolmentClass.permittedDomain) 
          ? Array.isArray(this.enrolmentClass.permittedDomain)
            ? this.enrolmentClass.permittedDomain 
            : this.enrolmentClass.permittedDomain.split(',')
          : []
      },
    },

    async mounted () {
      console.log('baseurl = ', cookies.get('baseUrl'))
      if (this.$route.query.locale) {
        this.$i18n.locale = this.$route.query.locale
      }

      if (!this.$route.query.enrolmentKey) {
        this.error = this.$t('enrol.bad-link')
        return
      }
      try {
        this.loading = true
        // console.log(this.$route.query)
        this.enrolmentClass = await api.getEnrolmentDetails(this.$route.query.enrolmentKey, this.$route.query.enrolmentDate)
        // console.log(this.enrolmentClass)
        // check cookies
        if (cookies.get('email')) {
          this.remember = true
        }
        this.email = cookies.get('email') ?? ''
        this.displayName = cookies.get('displayName') ?? ''
        this.loading = false
      } catch (ex) {
        this.loading = false
        this.error = ex.response.data ?? ex.message
      }
    },

    methods: {
      reload () {
        window.location.reload(true)
      },
      isDomainPermitted (domain) {
        return this.permittedDomainArray.length === 0 || this.permittedDomainArray.some(d => domain === d)
      },
      permittedDomain (value) {
        const domain = value.substring(value.indexOf('@'))
        
        if (this.permittedDomainArray.length === 0) {
          return true
        }
        return this.isDomainPermitted(domain) || this.$t('enrol.email-must-end-with') + this.permittedDomainArray.join(', ')
      },
      async submit () {
        this.error = null
        this.loading = true
        try {
          const res = await api.userSelfEnrol({
            key: this.$route.query.enrolmentKey,
            name: this.displayName,
            email: this.email,
            returnURL: process.env.VUE_APP_URL + '/#/launch',
          })
          // Check if requires email validation - if so then give them a message to check
          // Other wise redirect to the class join page.
          if (this.remember) {
            cookies.set('email', this.email, 60)
            cookies.set('displayName', this.displayName, 60)
          } else {
            cookies.remove('email')
            cookies.remove('displayName')
          }

          if (res && res.redirectLink) {
            this.redirectURL = res.redirectLink
            const inst = setInterval(() => {
              window.location.href = res.redirectLink
              clearInterval(inst) }, 3000)
          }
          this.complete = true
          this.loading = false
        } catch (ex) {
          // console.log(ex.message)
          if (ex.message.includes('404'))
          {
            this.error = 'emailNotFound'
          } if (ex.message.includes('403')) {
            this.error = 'max_users'
          } else {
            this.error = ex.message
          }
          this.loading = false
        }
      },
    },
  }
</script>

<style>
#mark {
  width: 32px;
  margin-right: 10px;
}

p {
  line-height: 1.5;
}
</style>
